import styled from "styled-components";
import { colors } from "globalStyles";

export const Wrapper = styled.div`
  padding: 24px 0;

  h1 {
    font-size: 24px;
    font-weight: bold;
    color: ${colors.DARK_GRAY};
    margin-bottom: 16px;
  }

  .admin-gifs__error,
  .admin-gifs__empty {
    font-size: 14px;
    font-weight: normal;
    color: ${colors.MEDIUM_GRAY};
    padding: 24px 0;
  }
`;

export const BackLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-bottom: 16px;
  cursor: pointer;
  font-size: 13px;
  color: ${colors.SILKBLUE};
`;

export const DetailHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
`;

export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

// Display-only field caption for the read-only detail view — a <span>, not a
// <label>, since it labels static text rather than a form control (matches the
// Users module's DetailLabel pattern; avoids an orphaned htmlFor-less <label>).
export const DetailLabel = styled.span`
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${colors.MEDIUM_GRAY};
`;

export const FieldValue = styled.div`
  font-size: 15px;
  color: ${colors.DARK_GRAY};
`;

// Status-semantic colors for the approval pill — named here (rather than inline
// hex) so the intent reads clearly and the values have one home. These are
// status semantics not present in the shared `colors` token map.
const STATUS_GREEN_FG = "#1b7f3b";
const STATUS_GREEN_BG = "#e6f4ea";
const STATUS_AMBER_FG = "#8a6d00";
const STATUS_AMBER_BG = "#fdf3d7";

// Approval status pill — green when approved, amber when still pending.
export const StatusPill = styled.span`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: bold;
  color: ${(props) => (props.$approved ? STATUS_GREEN_FG : STATUS_AMBER_FG)};
  background: ${(props) => (props.$approved ? STATUS_GREEN_BG : STATUS_AMBER_BG)};
`;
